<ng-container *ngIf="mode === 'bar' || mode === 'both'">
  <div class="badge-container">
    <div class="badge" [class.pending-badge]="milestone.percentage > currentValuePercentage" *ngFor="let milestone of goal.milestones" [style.left]="milestone.percentage + '%'">
      <img src="{{ milestone.percentage <= currentValuePercentage ? goalCompletedImagePath : goalPendingImagePath }}">
      <div class="arrow-down"></div>
    </div>
  </div>
  <div class="bar-container">
    <div class="current-bar"></div>
    <div class="current-value">{{ currentValue | number }} {{ unit }}</div>
  </div>
  <div *ngIf="goal?.number" class="progress-legend" >{{ currentValue | number }} Out of {{ goal.number | number }} Needed</div>
</ng-container>
<ng-container *ngIf="mode === 'milestones' || mode === 'both'">
  <div class="milestone" *ngFor="let milestone of goal.milestones">
    <div class="image"><img src="{{ milestone.percentage <= currentValuePercentage ? goalCompletedImagePath : goalPendingImagePath }}"></div>
    <div class="goal">{{ milestone.percentage }}% Goal</div>
    <div class="label">{{ milestone.label }}</div>
    <div></div>
  </div>
</ng-container>
